<template>
  <div :style="styles.wrapper" class="contacts__wrapper">
    <!-- <div :style="styles.header">
      <div class="header__close" v-if="enableCloseMenu" :style="styles.headerClose"
        @click="emitAction('closeMenuClicked')"></div>
      <h4 :style="styles.headerTitle">{{ STRINGS.USERS }}</h4>
    </div> -->
    <div :style="styles.search" class="search_input">
      <input type="text" class="h-12 black white--text" autocomplete="off" :style="styles.searchInput"
        :placeholder="STRINGS.SEARCH" @input="userSearchHandler" />
    </div>

    <LoadingSpinner v-if="chatsLoader" class="bg-transparent !relative !h-[calc(100vh-290px)]" />
    <v-list dark
      :class="`mb-5 py-2 mx-4 justify-center !max-h-[80px] gray rounded-lg black red_list font-Handel text-center ${premiumLayout ? 'mx-10 !border-[1px] !border-gray-300 ' : ''} `"
      v-else-if="friendsList.length < 1">
      No Chats Available
    </v-list>
    <v-list class="transparent !overflow-y-auto !h-[calc(100vh-190px)]" v-else>
      <v-list-item-group v-model="selectedChat" :color="`${routeType}primary `">
        <v-list-item dark v-for="(chat , idx) in friendsList" :key="chat.uid"
        v-motion :initial="{ opacity: 0, y: 100 }" :enter="{
          opacity: 1, y: 0, transition: {
            duration: 400,
            type: 'keyframes',
            ease: 'backInOut',
            delay: `${idx}00`,
          },
        }"
          class="mb-5 py-2 mx-4 gray rounded-lg black red_list " @click.prevent="userClickHandler(chat)">
          <v-badge dot offset-x="10" offset-y="10" bordered overlap
            :color="`${chat.status}` == 'online' ? 'green' : 'grey'">
            <v-avatar size="40" :class="`!border-2 ${routeLink}-border `">
              <v-img position="top center" :src="chat.avatar" alt />
            </v-avatar>
          </v-badge>
          <v-list-item-content class="ml-3">
            <v-list-item-title class=" font-Handel !text-base !capitalize" :class="`${routeLink}_fortext`">{{
              chat.name
            }} </v-list-item-title>
            <v-list-item-title class="!text-gray-400 font-Handel !text-sm">
              {{ chat.typingIndicator ? chat.typingIndicator : chat.status }}</v-list-item-title>
          </v-list-item-content>
          <span v-show="chat.unreadMessages > 0 && selectedUser.name != chat.name"
            :class="`float-right px-3 text-black font-Inter font-semibold text-xs py-[2px] rounded-2xl ${routeLink + `_color`} `">{{
  chat.unreadMessages
            }}</span>

        </v-list-item>
      </v-list-item-group>
    </v-list>
  </div>

</template>

<!--eslint-disable-->
<script>
import {
  COMETCHAT_CONSTANTS,
  DEFAULT_OBJECT_PROP,
  DEFAULT_BOOLEAN_PROP,
} from "../../../resources/constants";
import { CometChat } from "@cometchat-pro/chat";
import { CometChatManager } from "../../../util/controller";
import { SvgAvatar } from "../../../util/svgavatar";
import { UserListManager } from "./controller";

import { theme } from "../../../resources/theme";

import { propertyCheck, cometChatCommon } from "../../../mixins/";

import searchIcon from "./resources/search-grey-icon.svg";
import navigateIcon from "./resources/navigate.png";

import CometChatUserListItem from "../CometChatUserListItem/CometChatUserListItem";

import * as style from "./style";
import { RouterLink } from "vue-router";
import axios from "axios";
import LoadingSpinner from "@/pages/front/straight/childs/LoadingSpinner.vue";


let timeout;
let GetUsertimeout;
let friendsOnly;
let userListManager;
let currentLetter = "";

/**
 * Displays list of users.
 *
 * @displayName CometChatUserList
 */
export default {
  name: "CometChatUserList",
  mixins: [propertyCheck, cometChatCommon],
  components: {
    CometChatUserListItem,
    LoadingSpinner
  },
  props: {
    /**
     * The selected chat item object.
     */
    item: { ...DEFAULT_OBJECT_PROP },
    /**
     * Theme of the UI.
     */
    theme: { ...DEFAULT_OBJECT_PROP },
    /**
     * Flag for friends only filter.
     */
    navDrawer: { ...DEFAULT_BOOLEAN_PROP },
    friendsOnly: { ...DEFAULT_BOOLEAN_PROP },
    /**
     * Shows/hides the close menu button.
     */
    enableCloseMenu: { ...DEFAULT_BOOLEAN_PROP },
  },
  data() {
    return {
      selectedChat: null,
      userList: [],
      usersRequest: "",
      selectedUser: {},
      decoratorMessage: COMETCHAT_CONSTANTS.LOADING_MESSSAGE,
      typingIndicator: false,
      chatsLoader: false,
    };
  },
  computed: {
    friendsList() {
      if (!this.navDrawer) {
        return this.$store.getters.friendsList
      } else {
        return this.$store.getters.friendsList.slice(0, 4)
      }

    },
    premiumLayout() {
      return this.$store.getters.isPremiumLayout
    },
    /**
     * Theme computed using default theme and theme coming from prop.
     */
    themeValue() {
      return Object.assign({}, theme, this.theme || {});
    },
    /**
     * Local string constants.
     */
    STRINGS() {
      return COMETCHAT_CONSTANTS;
    },
    /**
     * Computed styles for the component.
     */

    styles() {
      return {
        msg: style.contactMsgStyle(),
        list: style.contactListStyle(),
        search: style.contactSearchStyle(),
        wrapper: style.contactWrapperStyle(),
        alphabet: style.contactAlphabetStyle(),
        header: style.contactHeaderStyle(this.themeValue),
        msgText: style.contactMsgTxtStyle(this.themeValue),
        headerClose: style.contactHeaderCloseStyle(navigateIcon),
        headerTitle: style.contactHeaderTitleStyle(this.enableCloseMenu),
        searchInput: style.contactSearchInputStyle(this.themeValue, searchIcon),
      };
    },
  },
  watch: {
    'userList': {
      handler: async function () {
        // this.getUsers();
        const cometChatManager = new CometChatManager();

        await cometChatManager.getLoggedInUser();
        // console.log(this.userList)
        //  console.log(id.uid);

        const routeUid = this.$route.query.uid;
        if (routeUid) {
          console.log(this.userList)
          if (this.userList.length > 0) {
            let user = this.userList.find((u) => u.uid == routeUid);
            console.log(user)
            this.emitAction("item-click", { item: user, type: "user" });
          }
        }

      },
      deep: true,
      immediate: true
    },
    '$route.query': {
      handler: async function (id) {
        if (id.uid) {
          const routeUid = this.$route.query.uid;
          if (this.$store.getters.friendsList.length > 0) {
            let user = this.$store.getters.friendsList.find((u) => u.uid == routeUid);
            console.log(user)
            this.emitAction("item-click", { item: user, type: "user" });
          }
        }
      },
      deep: true,
      immediate: true
    },
    /**
     * Updates local state on change of item.
     */
    item: {
      handler(newItem, oldItem) {
        const previousItem = JSON.stringify(oldItem);
        const currentItem = JSON.stringify(newItem);
        // console.log("previousItem:", oldItem, "currentItem:", newItem);
        if (previousItem !== currentItem) {
          // this.$store.dispatch("fetchUnreadMessages");
          // let userKey = this.userList.findIndex((u) => u.uid === newItem.uid);
          // this.userList[userKey].unreadMessages = currentItem.unreadMessages;
          if (Object.keys(newItem).length === 0) {
            this.$nextTick(() => {
              if (this.$refs.userListRef) {
                this.$refs.userListRef.scrollTop = 0;
              }
            });
            this.selectedUser = {};
          } else {
            let userList = [...this.userList];

            let userKey = userList.findIndex((u) => u.uid === newItem.uid);
            if (userKey > -1) {
              let userObj = { ...userList[userKey] };
              this.selectedUser = userObj;

            }
          }

        }

        if (
          oldItem &&
          Object.keys(oldItem).length &&
          oldItem.uid === newItem.uid &&
          oldItem.blockedByMe !== newItem.blockedByMe
        ) {
          let userList = [...this.userList];

          let userKey = userList.findIndex((u) => u.uid === newItem.uid);
          if (userKey > -1) {
            let userObj = { ...userList[userKey] };
            let newUserObj = Object.assign({}, userObj, {
              blockedByMe: newItem.blockedByMe,
            });
            userList.splice(userKey, 1, newUserObj);
            this.userList = userList;
          }
        }

      },
      deep: true,
    },
  },
  methods: {
    /**
     * Handles user search
     */
    userSearchHandler(e) {
      if (timeout) {
        clearTimeout(timeout);
      }
      let val = e.target.value;
      timeout = setTimeout(() => {
        userListManager = new UserListManager(friendsOnly, val);
        this.getUsers(true);
      }, 300);
    },
    /**
     * Handles click on user
     */
    userClickHandler(user) {
      if (this.$route.query.uid != user.uid) {
        this.$router.replace({
          name: "Chats",
          query: {
            uid: user.uid,
          },
        });
        this.setCenterView();
        this.emitAction("item-click", { item: user, type: "user" });
        const userSelect = this.userList.find((u) => u.uid == user.uid);
        userSelect.unreadMessages = "0"

      }
    },
    /**
     * Parses and return alphabet for list
     */
    getAlphabet(user) {
      const chr = user.name[0].toUpperCase();
      if (chr !== currentLetter) {
        currentLetter = chr;
        return chr;
      } else {
        return null;
      }
    },
    /**
     * Handles user list scroll
     */
    userScrollHandler(elem) {
      if (
        elem.target.offsetHeight + elem.target.scrollTop >=
        elem.target.scrollHeight - 20
      ) {
        this.getUsers();
      }
    },
    /**
     * Gets list of users
     */

    async getUsers(clear = false) {
      clearTimeout(GetUsertimeout);
      GetUsertimeout = setTimeout(async () => {
        const cometChatManager = new CometChatManager();
        try {
          this.chatsLoader = true;
          await cometChatManager.getLoggedInUser();
          if (!userListManager) {
            userListManager = new UserListManager(friendsOnly);
          }
          const users = await userListManager.fetchNextUsers();
          console.log("test", users)

          if (users.length === 0) {
            this.decoratorMessage = COMETCHAT_CONSTANTS.ERROR_NO_USERS_FOUND;
          }
          const objeAllUnread = this.$store.getters.IndiUnreadMessages;
          users.forEach((user) => (user = this.setAvatar(user)));
          users.forEach((user) => user.typingIndicator = '');
          users.forEach((user) => user.unreadMessages = '0');
          users.forEach((user) => {
            for (const [uid, unread] of Object.entries(objeAllUnread)) {
              if (uid === user.uid) {
                user.unreadMessages = unread;
              }
            }
          });

          if (clear) {
            this.userList = users;
            this.$store.dispatch('getFriends', this.userList)
          } else {
            this.userList = [...this.userList, ...users];
            this.$store.dispatch('getFriends', this.userList)
          }
        } catch (error) {
          this.decoratorMessage = COMETCHAT_CONSTANTS.ERROR_LOADING_USERS;
          console.error("[CometChatUserList] getUsers fetchNext error", error);
        } finally {
          this.chatsLoader = false;
        }
      })
    },
    /**
     * Sets SVG avatar
     */
    setAvatar(user) {
      if (!user.getAvatar()) {
        const uid = user.getUid();
        // const resp = await axios.get('all-profiles')
        // console.log(uid)
        // console.log(resp.data.data.data.find((profile) => profile.uuid == uid))
        const char = user.getName().charAt(0).toUpperCase();
        user.setAvatar(SvgAvatar.getAvatar(uid, char));
      }
    },
    /**
     * Handles listener events
     */
    usersUpdateHandler(user) {
      this.logInfo("CometChatUserList :usersUpdateHandler", { user });
      let users = [...this.userList];

      let userKey = users.findIndex((u) => u.uid === user.uid);

      if (userKey > -1) {
        let userObj = { ...users[userKey] };
        let newUserObj = { ...userObj, ...user };
        users.splice(userKey, 1, newUserObj);

        this.userList = users;
      }
    },

  },
  beforeMount() {
    friendsOnly = this.friendsOnly;

    userListManager = new UserListManager(friendsOnly);
    userListManager.attachListeners(this.usersUpdateHandler);
    let listenerId = "UNIQUE_LITENER_ID";

    CometChat.addMessageListener(
      listenerId,
      new CometChat.MessageListener({
        onTypingStarted: typingIndicator => {
          // console.log("Typing started :", typingIndicator);
          this.userList.find((u) => u.uid == typingIndicator.sender.uid).typingIndicator = 'Typing...'
          // console.log(this.userList)
        },
        onTypingEnded: typingIndicator => {
          // console.log("Typing ended :", typingIndicator);
          this.userList.find((u) => u.uid == typingIndicator.sender.uid).typingIndicator = ''
          // console.log(this.userList)
        }
      })
    );
    
  },
  mounted() {
    this.getUsers();
    
  },
  beforeDestroy() {
    if (userListManager) {
      userListManager.removeListeners();
      userListManager = null;
    }
  },
  beforeUnmount() {
    if (userListManager) {
      userListManager.removeListeners();
      userListManager = null;
    }
  },
  async created() {
    this.$store.subscribe((mutation, state) => {
      if (mutation.type === "setIndiUnreadMessages") {

        const objeAllUnread = this.$store.getters.IndiUnreadMessages;
        this.userList.forEach((user) => {
          // console.log(mutation);
          for (const [uid, unread] of Object.entries(objeAllUnread)) {
            if (uid === user.uid) {
              user.unreadMessages = unread;
              console.log('test', user.unreadMessages)
            }
          }
        });
      }
    });

  }
};
</script>
<style scoped>
/* .contacts__wrapper * {
  box-sizing: border-box;
} */

.red_list.v-list-item--active {
  background: black;

}

.red_list.v-list-item--active .v-list-item__title {
  background: white;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;

}

.red_list.v-list-item--active:before {
  background: black
}

.red_list.v-list-item--link:before {
  border-radius: 8px;
}

@media (min-width: 320px) and (max-width: 767px) {
  .header__close {
    display: block !important;
  }
}

.straight_fortext {
  /* background: rgb(177, 145, 65); */
  background: linear-gradient(335deg,
      rgb(136 97 0) 0%,
      rgb(255 223 153) 53%,
      rgb(130 93 0 / 97%) 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.gay_fortext {
  /* background: rgb(177, 145, 65); */
  background: linear-gradient(357deg,
      rgba(0, 240, 255, 1) 55%,
      rgba(0, 156, 255, 1) 75%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.lesbian_fortext {
  /* background: rgb(177, 145, 65); */
  background: linear-gradient(208deg,
      rgba(126, 0, 157, 0.9416141456582633) 2%,
      rgba(161, 51, 246, 1) 45%,
      rgba(157, 0, 176, 0.9668242296918768) 96%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.straight-border {
  border-color: #a07a1d;
}

.gay-border {
  border-color: #88c3fa;
}

.lesbian-border {
  border-color: #9e2eec;
}
</style>